import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "horizontalOnMobile", "includeTablet", "children"],
  _excluded2 = ["className", "children", "includeTablet", "title"],
  _excluded3 = ["className", "children", "includeTablet", "loading"],
  _excluded4 = ["className", "intl", "isEmpty", "children", "emptyMessage", "emptyRowColSpan", "includeTablet"],
  _excluded5 = ["classes", "intl", "withBorder", "nextIconButtonProps", "backIconButtonProps", "onChangePage", "onPageChange", "onChangeRowsPerPage", "onRowsPerPageChange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import withWidth, { isWidthUp } from 'muiCompat/withWidth';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import MUITablePagination from '@mui/material/TablePagination';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import ContextProvider from '../../../context';
import messages from './tableMessages';
import s from './Table.scss';
var Row = function Row(_ref) {
  var _classNames;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$horizontalOnMobi = _ref.horizontalOnMobile,
    horizontalOnMobile = _ref$horizontalOnMobi === void 0 ? false : _ref$horizontalOnMobi,
    _ref$includeTablet = _ref.includeTablet,
    includeTablet = _ref$includeTablet === void 0 ? false : _ref$includeTablet,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TableRow, _extends({
    className: classNames((_classNames = {}, _defineProperty(_classNames, s.tableRow, !horizontalOnMobile), _defineProperty(_classNames, s.tableRowHorizontal, horizontalOnMobile), _defineProperty(_classNames, s.includeTablet, includeTablet), _classNames), className)
  }, rest), children);
};
var Cell = function Cell(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? null : _ref2$children,
    _ref2$includeTablet = _ref2.includeTablet,
    includeTablet = _ref2$includeTablet === void 0 ? false : _ref2$includeTablet,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(TableCell, _extends({
    "data-title": title,
    className: classNames(s.tableCell, _defineProperty({}, s.includeTablet, includeTablet), _defineProperty({}, s.cellBefore, !!title), s.generalStylesCell, className)
  }, rest), children);
};
var TableWrap = function TableWrap(_ref3) {
  var _classNames4;
  var _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$children = _ref3.children,
    children = _ref3$children === void 0 ? null : _ref3$children,
    _ref3$includeTablet = _ref3.includeTablet,
    includeTablet = _ref3$includeTablet === void 0 ? true : _ref3$includeTablet,
    _ref3$loading = _ref3.loading,
    loading = _ref3$loading === void 0 ? false : _ref3$loading,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsx("div", {
    className: s.lineOverflow
  }, void 0, /*#__PURE__*/React.createElement(Table, _extends({
    className: classNames(s.table, className, (_classNames4 = {}, _defineProperty(_classNames4, s.includeTablet, includeTablet), _defineProperty(_classNames4, s.loading, loading), _classNames4))
  }, rest), children));
};
var BodyWrap = function BodyWrap(_ref4) {
  var _ref4$className = _ref4.className,
    className = _ref4$className === void 0 ? '' : _ref4$className,
    formatMessage = _ref4.intl.formatMessage,
    isEmpty = _ref4.isEmpty,
    _ref4$children = _ref4.children,
    children = _ref4$children === void 0 ? null : _ref4$children,
    _ref4$emptyMessage = _ref4.emptyMessage,
    emptyMessage = _ref4$emptyMessage === void 0 ? messages.emptyTableMessage : _ref4$emptyMessage,
    _ref4$emptyRowColSpan = _ref4.emptyRowColSpan,
    emptyRowColSpan = _ref4$emptyRowColSpan === void 0 ? 24 : _ref4$emptyRowColSpan,
    _ref4$includeTablet = _ref4.includeTablet,
    includeTablet = _ref4$includeTablet === void 0 ? false : _ref4$includeTablet,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  var context = useContext(ContextProvider);
  var organizationSlug = context.organizationSlug;
  return /*#__PURE__*/React.createElement(TableBody, _extends({
    className: classNames(className)
  }, rest), isEmpty ? /*#__PURE__*/_jsx(TableRow, {}, void 0, /*#__PURE__*/_jsx(TableCell, {
    className: classNames(s.tableBodyEmptyRow, s.includeTablet, _defineProperty({}, s.whitelabeled, !!organizationSlug)),
    colSpan: emptyRowColSpan
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: classNames(s.emptyTableImg, _defineProperty({}, s.whitelabeled, !!organizationSlug))
  }), formatMessage(emptyMessage))) : children);
};
var EmptyRow = function EmptyRow(_ref5) {
  var width = _ref5.width,
    count = _ref5.count,
    _ref5$colSpan = _ref5.colSpan,
    colSpan = _ref5$colSpan === void 0 ? 16 : _ref5$colSpan,
    _ref5$rowHeight = _ref5.rowHeight,
    rowHeight = _ref5$rowHeight === void 0 ? 49 : _ref5$rowHeight,
    _ref5$className = _ref5.className,
    className = _ref5$className === void 0 ? '' : _ref5$className,
    _ref5$breackpointWidt = _ref5.breackpointWidth,
    breackpointWidth = _ref5$breackpointWidt === void 0 ? 'sm' : _ref5$breackpointWidt;
  return isWidthUp(breackpointWidth, width) && count > 0 ? /*#__PURE__*/_jsx(TableRow, {
    style: {
      height: rowHeight * (count === 10 ? count - 1 : count)
    },
    className: className
  }, void 0, /*#__PURE__*/_jsx(ResponsiveTableCell, {
    colSpan: colSpan
  })) : null;
};
var ChangeOfInPagination = function ChangeOfInPagination(_ref6) {
  var from = _ref6.from,
    to = _ref6.to,
    count = _ref6.count;
  return "".concat(from, " - ").concat(to, " / ").concat(count);
};
var Pagination = function Pagination(_ref7) {
  var classes = _ref7.classes,
    formatMessage = _ref7.intl.formatMessage,
    withBorder = _ref7.withBorder,
    nextIconButtonProps = _ref7.nextIconButtonProps,
    backIconButtonProps = _ref7.backIconButtonProps,
    onChangePage = _ref7.onChangePage,
    onPageChange = _ref7.onPageChange,
    onChangeRowsPerPage = _ref7.onChangeRowsPerPage,
    onRowsPerPageChange = _ref7.onRowsPerPageChange,
    rest = _objectWithoutProperties(_ref7, _excluded5);
  var pageChangeHandler = onPageChange || onChangePage;
  var rowsPerPageChangeHandler = onRowsPerPageChange || onChangeRowsPerPage;
  return /*#__PURE__*/React.createElement(MUITablePagination, _extends({
    labelDisplayedRows: ChangeOfInPagination,
    classes: _objectSpread(_objectSpread({
      toolbar: s.tablePaginationToolbar,
      actions: s.tablePaginationActions
    }, classes), {}, {
      root: classNames(_defineProperty({}, s.tablePaginationRoot, !withBorder), _.get(classes, 'root'))
    }),
    nextIconButtonProps: _objectSpread({
      'aria-label': formatMessage(messages.nextIconAriaLabel),
      title: formatMessage(messages.nextIconAriaLabel)
    }, nextIconButtonProps),
    backIconButtonProps: _objectSpread({
      'aria-label': formatMessage(messages.backIconAriaLabel),
      title: formatMessage(messages.backIconAriaLabel)
    }, backIconButtonProps),
    onPageChange: pageChangeHandler,
    onRowsPerPageChange: rowsPerPageChangeHandler
  }, rest));
};
export var GroupChipWithoutStyles = function GroupChipWithoutStyles(_ref8) {
  var name = _ref8.name;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: name
  }, void 0, /*#__PURE__*/_jsx(Chip, {
    label: name,
    className: s.chip
  }));
};
export var ResponsiveTable = withStyles(s)(TableWrap);
export var ResponsiveTableRow = withStyles(s)(Row);
export var ResponsiveTableCell = withStyles(s)(Cell);
export var ResponsiveTableBody = injectIntl(withStyles(s)(BodyWrap));
export var EmptyRows = withWidth()(EmptyRow);
export var TablePagination = injectIntl(withStyles(s)(Pagination));
export var GroupChip = withStyles(s)(GroupChipWithoutStyles);